import { OauthAEMConfig } from './config.interfaces';
import { Errors, PingFederateError } from './errors.interfaces';
import { PkceCode } from './oauth.interfaces';

export interface SwapAuthForAccessTokensParams {
  authorizationCode: string | undefined;
  oauthConfig: OauthAEMConfig;
  pkcCodeGenerated: PkceCode;
}

export interface SwapAuthForAccessTokens {
  access_token?: string;
  expires_in?: number;
  id_token?: string;
  token_type?: string;
  error?: PingFederateError;
  errors?: Errors[];
  code?: string;
  error_description?: string;
  encyToken?: string;
  uid?: string;
}

export interface AuthAccessTokenDetails {
  access_token: string;
  expires_in?: number;
  token_issued_time: number;
  encyToken?: string;
  uid?: string;
}

export interface TokenDetails {
  token: string;
  tokenAvailable: string;
  issueTime: number;
  expiresIn: number;
  eamStatus?: string;
}

export interface DecodedToken {
  scope?: string;
  authorization_details?: null[] | null;
  client_id?: string;
  iss?: string;
  jti?: string;
  aud?: string;
  sub?: string;
  level_of_trust?: string;
  iat?: number;
  mdc?: number;
  exp?: number;
}
